module.exports = __webpack_public_path__ + "static/media/hands_16.3a5b45f0.svg";